<template>
  <div class="text-left">
    <mdb-card>
      <mdb-card-header color="secondary">
        {{ formTitle }}
      </mdb-card-header>
      <mdb-card-body>
        <div class="md-form">
          <mdb-input label="Title" id="title" placeholder="Enter a title for this suggestion." type="text"
                     v-model="suggestion.title"/>
        </div>
        <div class="md-form">
          <input aria-label="I'm willing to host." class="form-control form-check-input" id="willingToHost" type="checkbox"
                 v-model="suggestion.willingToHost"/>
          <label for="willingToHost">I'm willing to host this event </label>
        </div>
        <div class="md-form">
          <datetime :auto="true"
                    :format="userDetails.dateFormat"
                    :valueZone="userDetails.timezone"
                    :week-start="userDetails.mondayFirst ? 1 : 7"
                    :zone="userDetails.timezone"
                    id="from-input"
                    v-model="suggestion.startDate"></datetime>
          <label class="active mr-5">Date</label>
          <div class="text-info">Leave date blank if it's open for discussion.</div>
        </div>
        <div class="md-form">
          <h5>Description of Suggestion</h5>
          <editor :init="editorConfig" v-model="suggestion.description"/>
        </div>
        <div class="mb-2">
          <label>Venue</label>
          <mdb-input id="v0" label="A Place We've Been Before" name="v0" radioValue="existing" type="radio"
                     v-model="venueMode"/>
          <mdb-input id="v1" label="A New Place" name="v1" radioValue="new" type="radio"
                     v-model="venueMode"/>
        </div>
        <div class="md-form" v-if="venueMode == 'existing'">
          <gp-select v-if="allVenues.length>0" :dataObj="suggestion" :possible-values="allVenues" :required="true" label="Venue"
                     propertyName="venueId" id="venue-id"/>
        </div>
        <div class="md-form" v-if="venueMode == 'new'">
          <h5>Describe the New Venue</h5>
          <editor :init="editorConfig" v-model="suggestion.newVenueDescription"/>
        </div>
        <mdb-btn :disabled="!okToSubmit" @click="$emit('save')" color="success" icon="check">{{ buttonTitle }}</mdb-btn>
        <mdb-btn @click="$emit('cancel')" color="warning" icon="ban">Cancel</mdb-btn>

      </mdb-card-body>
    </mdb-card>
  </div>
</template>

<script>
import {mdbBtn, mdbCard, mdbCardBody, mdbCardHeader, mdbInput, mdbSelect} from 'mdbvue';
import BannerSmall from "../group/BannerSmall";
import {Datetime} from 'vue-datetime';
import editor from '@tinymce/tinymce-vue'
import api from "../../services/groupsPlaceApi";
import gpSelect from "../common/GPSelect";

export default {
  name: 'Suggestion-Editor',
  components: {
    mdbCard,
    mdbCardHeader,
    mdbCardBody,
    mdbBtn,
    mdbInput,
    mdbSelect,
    BannerSmall,
    editor,
    Datetime,
    gpSelect
  },
  props: {
    suggestion: {
      type: Object,
      default: null
    }
  },
  mounted()  {
    if (this.suggestion.newVenueDescription) this.venueMode = "new";
    api.get("/venue/listActive/" + this.currentGroup.vanityPath).then(
      (results) => {
        this.allVenues = results.data
      },
      (error) => {
        this.$notify.error({message: "Could not load venue list. " + error.response.data, timeOut: 10000})
      })

    let el = document.getElementById("title")
    if (el) el.focus()
  },
  watch: {
    venueMode(n,o) {
      if (n=="new") this.suggestion.venueId = null
      if (n=="existing") this.suggestion.newVenueDescription = null
    }
  },
  computed: {
    okToSubmit() {
      if (!this.suggestion.title) return false
      if (!this.suggestion.description) return false
      if (this.venueMode == "new" && !this.suggestion.newVenueDescription) return false
      if (this.venueMode == "existing" && !this.suggestion.venueId) return false
      return true
    },
    formTitle() {
      if (this.suggestion.id) return "Edit Suggestion"
      else return "New Suggestion"
    },
    buttonTitle() {
      if (this.suggestion.id) return "Save Changes"
      else return "Submit Suggestion"
    },
    userDetails: function () {
      return this.$store.state.userDetails
    },
    currentGroup: function() {
      return this.$store.state.currentGroup
    }
  },
  data() {
    return {
      allVenues: [],
      editorConfig: {
        browser_spellcheck: true,
        branding: false,
        plugins: ["link", "code", "paste", "table", "lists"],
        toolbar: ["undo redo cut copy paste bold italic underline numlist bullist fontsizeselect | alignleft alignright aligncenter | styleselect | link unlink code "],
        style_formats_merge: true,
        paste_as_text: true,
        relative_urls: false,
        remove_script_host: false,
        height: 400
      },
      venueMode: "existing"
    }
  },
  methods: {
    valueSelected(venue) {
      this.suggestion.venueId = venue
    }
  }
}
</script>
<style lang="scss">
@import '~vue-datetime/dist/vue-datetime.min';
</style>
